export class ZonasLiberaciones{
  id: number;
  idZonaLiberacion:string;
  idZona:string;
  idCausalLiberacion:string;
  idEjecutivo:string;
  observacion:string;
  indicadorHabilitado:boolean;
  auditoriaUsuario: string;
  auditoriaFecha:Date;
}
